import { ISuggestSchema } from '../../services/offersSuggestions';

const defaultState = null;

export function offersSuggestionsReducer(state: ISuggestSchema | null = defaultState): ISuggestSchema | null {
  return state;
}
